import { useState } from 'react'
import { startCase } from 'lodash'

import { CardType } from 'types/deck'
import { Option } from 'components/elements/ArchidektDropdown/types'

import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import PhatButton from 'components/formElements/PhatButton'

import styles from './oTagQuickOptions.module.scss'

type Props = {
  card: CardType
  onCardUpdate?: (updatedCard: CardType) => void
  disabled?: boolean
}

type SetAs = 'only' | 'primary' | 'secondary'

const OTagQuickOptions = ({ card, disabled, onCardUpdate }: Props) => {
  const [categoryAs, setCategoryAs] = useState<'only' | 'primary' | 'secondary'>('only')

  const handleUpdateCategory = (categoryName: string) => {
    let updatedCategories: string[] = [...card.categories]

    if (categoryAs === 'only') updatedCategories = [categoryName]
    else if (categoryAs === 'primary')
      updatedCategories = [categoryName, ...updatedCategories].filter(category => category === categoryName)
    else if (categoryAs === 'secondary')
      updatedCategories = [...updatedCategories, categoryName].filter(category => category === categoryName)

    if (onCardUpdate) onCardUpdate({ ...card, categories: updatedCategories })
  }

  const options: Option[] = [
    {
      type: 'checkbox',
      label: 'Set as only category',
      onChange: () => setCategoryAs('only'),
      checked: categoryAs === 'only',
    },
    {
      type: 'checkbox',
      label: 'Set as primary category',
      onChange: () => setCategoryAs('primary'),
      checked: categoryAs === 'primary',
    },
    {
      type: 'checkbox',
      label: 'Set as secondary category',
      onChange: () => setCategoryAs('secondary'),
      checked: categoryAs === 'secondary',
    },
    { type: 'spacer' },
  ]

  const tagToOption = (tagName: string): Option => ({
    label: startCase(tagName),
    onClick: () => handleUpdateCategory(startCase(tagName)),
    className: styles.tag,
  })

  if (card.oTags.length) options.push(...card.oTags.map(tagToOption))
  if (card.inheritedTags.length) {
    options.push({ type: 'spacer' })
    options.push(...card.inheritedTags.map(tagToOption))
  }

  const noOTags = !card.oTags.length && !card.inheritedTags.length

  return (
    <ArchidektDropdown disabled={noOTags || disabled} options={options} menuClassName={styles.menu}>
      <PhatButton icon="tags" className={styles.trigger} disabled={noOTags || disabled}>
        Oracle tags
      </PhatButton>
    </ArchidektDropdown>
  )
}

export default OTagQuickOptions
